export const videos = [
  {
    id: 'v001',
    title: '星光之城',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20with%20city%20skyline%20at%20night%20warm%20lighting%20cinematic%20composition%20soft%20bokeh%20background%20professional%20photography%20high%20quality&width=640&height=360&seq=mv-thumb-001&orientation=landscape',
    rating: 9.2,
    views: '1280万',
    episodes: '36集全',
    year: '2025',
    description: '一部关于都市青年追梦的励志剧集，讲述几位年轻人在大城市中奋斗成长的故事，温暖治愈又充满力量。',
    tags: ['热播', '都市', '励志'],
    isHot: true,
  },
  {
    id: 'v002',
    title: '深海迷踪',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Underwater%20cinematic%20scene%20with%20deep%20blue%20ocean%20mysterious%20atmosphere%20dramatic%20lighting%20from%20above%20suspended%20particles%20professional%20film%20photography%20high%20contrast&width=640&height=360&seq=mv-thumb-002&orientation=landscape',
    rating: 8.8,
    views: '3560万',
    episodes: '全1集',
    year: '2025',
    description: '深海探险题材科幻电影，一支科考队在万米深海发现未知文明遗迹，惊险刺激的冒险之旅。',
    tags: ['科幻', '冒险', 'IMAX'],
    isHot: true,
  },
  {
    id: 'v003',
    title: '笑林大会 第五季',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20stage%20show%20with%20bright%20studio%20lights%20cheerful%20atmosphere%20variety%20show%20set%20design%20warm%20color%20palette%20professional%20studio%20photography&width=640&height=360&seq=mv-thumb-003&orientation=landscape',
    rating: 9.5,
    views: '8920万',
    episodes: '更新至12期',
    year: '2026',
    description: '国内顶尖喜剧人齐聚一堂，爆笑不断，治愈不开心！全新赛制升级，笑料更加密集。',
    tags: ['热播', '搞笑', '综艺'],
    isHot: true,
  },
  {
    id: 'v004',
    title: '剑道无双',
    category: 'dongman',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20swordsman%20in%20traditional%20Japanese%20setting%20cherry%20blossom%20petals%20floating%20warm%20sunset%20lighting%20epic%20cinematic%20composition%20high%20detail%20illustration&width=640&height=360&seq=mv-thumb-004&orientation=landscape',
    rating: 9.0,
    views: '2150万',
    episodes: '更新至48集',
    year: '2026',
    description: '热门日漫改编，少年剑客踏上修行之路，热血战斗与真挚友情交织的冒险故事。',
    tags: ['热血', '战斗', '日漫'],
    isHot: false,
  },
  {
    id: 'v005',
    title: '地球脉动：极境之旅',
    category: 'jilupian',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20arctic%20landscape%20with%20glaciers%20and%20wildlife%20golden%20hour%20lighting%20pristine%20nature%20documentary%20style%20photography%20high%20resolution&width=640&height=360&seq=mv-thumb-005&orientation=landscape',
    rating: 9.8,
    views: '560万',
    episodes: '全8集',
    year: '2025',
    description: 'BBC级别制作团队深入极地，捕捉地球最震撼的自然奇观与野生动物生存故事。',
    tags: ['自然', '4K', 'BBC'],
    isHot: false,
  },
  {
    id: 'v006',
    title: '总裁的替嫁新娘',
    category: 'duanju',
    categoryName: '短剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20scene%20with%20elegant%20couple%20in%20modern%20luxury%20setting%20soft%20warm%20lighting%20dramatic%20cinematic%20composition%20beautiful%20aesthetic%20professional%20photography&width=640&height=360&seq=mv-thumb-006&orientation=landscape',
    rating: 8.5,
    views: '1.2亿',
    episodes: '全80集',
    year: '2026',
    description: '甜宠短剧爆款，替嫁新娘与总裁的意外爱情，一集上头根本停不下来。',
    tags: ['甜宠', '爆款', '短剧'],
    isHot: true,
  },
  {
    id: 'v007',
    title: 'NBA精彩集锦2026',
    category: 'tiyu',
    categoryName: '体育',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20basketball%20game%20action%20shot%20in%20professional%20arena%20dramatic%20lighting%20intense%20moment%20sports%20photography%20high%20speed%20capture%20professional%20quality&width=640&height=360&seq=mv-thumb-007&orientation=landscape',
    rating: 9.6,
    views: '4300万',
    episodes: '每日更新',
    year: '2026',
    description: '每日NBA赛事精华，绝杀、暴扣、妙传全收录，篮球迷不可错过的每日盛宴。',
    tags: ['NBA', '集锦', '篮球'],
    isHot: true,
  },
  {
    id: 'v008',
    title: '华语金曲盛典',
    category: 'yinyue',
    categoryName: '音乐',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20colorful%20lighting%20and%20atmospheric%20effects%20crowd%20silhouettes%20warm%20tones%20professional%20concert%20photography%20cinematic%20quality&width=640&height=360&seq=mv-thumb-008&orientation=landscape',
    rating: 9.1,
    views: '2890万',
    episodes: '更新至8期',
    year: '2026',
    description: '顶级华语歌手齐聚，经典金曲重新演绎，视听盛宴震撼人心。',
    tags: ['音乐', '演唱会', '华语'],
    isHot: false,
  },
];

export const featuredVideos = [
  {
    id: 'f001',
    title: '迷雾追踪',
    category: 'dianying',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspenseful%20cinematic%20night%20scene%20in%20rainy%20city%20street%20with%20mysterious%20atmosphere%20neon%20light%20reflections%20on%20wet%20pavement%20film%20noir%20style%20professional%20cinematography&width=800&height=450&seq=mv-feat-001&orientation=landscape',
    rating: 9.3,
    description: '悬疑烧脑巨制，一座小城连环谜案，真相层层揭开令人不寒而栗。',
    badge: '本周最热',
  },
  {
    id: 'f002',
    title: '欢乐喜剧人 第八季',
    category: 'zongyi',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20stage%20with%20spotlights%20and%20cheerful%20audience%20atmosphere%20variety%20show%20production%20design%20warm%20vibrant%20colors%20professional%20studio%20photography&width=800&height=450&seq=mv-feat-002&orientation=landscape',
    rating: 9.7,
    description: '王牌喜剧综艺重磅回归，笑匠云集，每期都是爆笑盛宴。',
    badge: '热播中',
  },
  {
    id: 'f003',
    title: '山河令之风云再起',
    category: 'dianshiju',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20drama%20scene%20with%20warriors%20in%20traditional%20costumes%20on%20mountain%20peak%20dramatic%20clouds%20and%20mist%20epic%20cinematic%20lighting%20professional%20photography&width=800&height=450&seq=mv-feat-003&orientation=landscape',
    rating: 9.4,
    description: '古装武侠巨制，江湖恩怨情仇，特效升级打造视觉奇观。',
    badge: '新剧上线',
  },
];